import history from 'config/history';

import { localizeUrl } from 'helpers/locales';

export const redirectTo = (currentUrl, redirectUrl) => {
  const localizedUrl = localizeUrl(currentUrl, redirectUrl);

  history.push(localizedUrl);
};
